import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-ds-xxxs",
        "text-ds-xxs",
        "text-ds-xsm",
        "text-ds-xxl",
        "text-ds-h2",
        "text-ds-h1",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function normalizeCaen(caen: string): string {
  if (!caen) return "";

  // Handle array case first
  if (Array.isArray(caen)) {
    return caen.map((code) => code.toString().padStart(4, "0")).join(", ");
  }

  // Handle string case - pad to 4 characters with leading zeros
  return caen.toString().padStart(4, "0");
}

export function formatScore(score: number): string | number {
  if (Number.isInteger(score)) {
    return score;
  }
  return score.toFixed(1).replace(".", ",");
}
